export { default } from './IconButton';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/IconButton/index.js
// module id = 113
// module chunks = 121